import { ReaderSection } from "../../types/helpCentre.types";
import FaqList from "./FaqList";
import MarkdownSection from "./MarkdownSection";
import VideoFolders from "./VideoFolders";

interface SectionContentProps {
	section: ReaderSection;
	/** The selected tab of a tabbed article, 0-based. */
	activeTab?: number;
	onTabChange?: (index: number) => void;
	/** An FAQ item to open and scroll to. */
	openFaqKey?: string | null;
}

/**
 * A section's content, by type. Data in, no fetching or URL state, so PR 5's
 * editor preview can render a section exactly as readers will see it.
 */
function SectionContent({
	section,
	activeTab,
	onTabChange,
	openFaqKey,
}: Readonly<SectionContentProps>) {
	switch (section.type) {
		case "markdown":
			return (
				<MarkdownSection
					markdown={section.markdown}
					activeTab={activeTab}
					onTabChange={onTabChange}
				/>
			);
		case "faq":
			return <FaqList items={section.faq} openKey={openFaqKey} />;
		case "folder":
			return <VideoFolders folders={section.folder} />;
	}
}

export default SectionContent;
